import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { OrientationFilter } from '~/components/Filters/OrientationFilter/OrientationFilter';
import { SingleFilterContainer } from '~/components/Filters/SingleFilters/SingleFilterContainer';
import { type SingleFilterProps } from '~/components/Filters/types';
import { clearStringArrayFilterValuesAction, setStringArrayFilterValuesAction } from '~/store/filters/actions';
import { selectedStringArrayFiltersSelector } from '~/store/filters/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export type SingleOrientationFilterProps = SingleFilterProps;

export const SingleOrientationFilter = memo(({ onApplyClick }: SingleOrientationFilterProps) => {
  const dispatch = useDispatch();
  const selectedOrientations = useAirSelector((st) => selectedStringArrayFiltersSelector(st, 'orientations'));
  const hasValues = selectedOrientations.length > 0;

  const clearValues = useCallback(() => {
    dispatch(clearStringArrayFilterValuesAction({ filter: 'orientations' }));
    onApplyClick();
  }, [dispatch, onApplyClick]);

  const onSelectionChange = useCallback(
    (values: string[]) => {
      dispatch(setStringArrayFilterValuesAction({ values, filter: 'orientations' }));
      onApplyClick();
    },
    [dispatch, onApplyClick],
  );

  return (
    <SingleFilterContainer
      hasValues={hasValues}
      currentFilter="orientation"
      onClearClick={clearValues}
      onApplyClick={onApplyClick}
    >
      <OrientationFilter selectedValues={selectedOrientations} onSelectionChange={onSelectionChange} />
    </SingleFilterContainer>
  );
});

SingleOrientationFilter.displayName = 'SingleOrientationFilter';
